import React from 'react';
import { Nullable } from 'global';
import { Typography } from '@mui/material';
import { Listing, useListing } from 'components/shared/TableListing';
import { BottomActionPanel } from './BottomActionPanel';
import { ScoreTierEntity, ScoreTiersTableContext } from '../types';
import { initialScoreTiersColumns, initialScoreTiersTableData, newTier } from '../constants';

interface Props {
  initialData: ScoreTierEntity[];
  onListingChange: (value: ScoreTierEntity[]) => void;
}

export const TiersBuilder = ({ initialData, onListingChange }: Props) => {
  const { form, columns, tableData, handleAddRow, handleRemoveRow } = useListing<
    ScoreTierEntity,
    ScoreTiersTableContext
  >(
    {
      headerColumns: initialScoreTiersColumns,
      bodyFields: initialData && initialData.length ? initialData : initialScoreTiersTableData,
    },
    { onSubscribe: onListingChange }
  );

  const handleCopyLastConfig = () => {
    const rows = form.getValues('bodyFields');
    handleAddRow(rows[rows.length - 1]);
  };

  return (
    <Listing<ScoreTierEntity, ScoreTiersTableContext>
      columns={columns}
      tableData={tableData}
      injectContext={{ form, handleRemoveRow }}
      actionPanelTop={() => (
        <Typography variant="h6" component="span">
          Score Tiers
        </Typography>
      )}
      actionPanelBottom={() => (
        <BottomActionPanel
          onCopyLast={handleCopyLastConfig}
          onAddRow={() => {
            handleAddRow(newTier);
          }}
        />
      )}
    />
  );
};
